
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_1uavz_93",
  "focus-lock": "awsui_focus-lock_145pa_1uavz_106",
  "calendar": "awsui_calendar_145pa_1uavz_110",
  "date-picker-container": "awsui_date-picker-container_145pa_1uavz_123",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_1uavz_128",
  "date-picker-input": "awsui_date-picker-input_145pa_1uavz_132",
  "open-calendar-button": "awsui_open-calendar-button_145pa_1uavz_137"
};
  